import {
  Injectable
} from '@angular/core';
import {
  Observable
,
  BehaviorSubject
,
  Subscription
} from 'rxjs';
import {
  ApiService
} from '../services/api';
import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';
import {UserContext} from '../services/user-context';

@Injectable()
export class ClientSessionService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;

  constructor(private api: ApiService, private userContext: UserContext) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  public getSessions(page: number, limit: number, cb: any, search?: string) {
    const params = new HttpParams()
    .set('page', page.toLocaleString())
    .set('limit', limit.toString())
    .set('search', search)
    .set('account', this.userContext.isAdministrator() && this.userContext.account ? this.userContext.account.id : '');

    this.subscription = this.api.get<GridDataResult>(`/account/${this.userContext.account.id}/session`, params)
      .subscribe(result => {
        super.next(result);
      });
  }
}
